import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MiscSnackBarService } from 'projects/core/src/lib/misc/view/snackbar/misc-snackbar.service';
import { AdminPanelService } from '../../../data/admin-panel.service';
import { ColumnForEdit } from '../../../data/column-for-edit';

@Component({
  selector: 'app-kb-column-editor-dialog',
  templateUrl: './kb-column-editor-dialog.component.html',
  styleUrls: ['./kb-column-editor-dialog.component.scss']
})
export class KbColumnEditorDialogComponent implements OnInit {
  saveLoading = false;
  tempColumn: ColumnForEdit;

  constructor(
    protected dialogRef: MatDialogRef<KbColumnEditorDialogComponent>,
    protected adminPanelService: AdminPanelService,
    private miscSnackBarService: MiscSnackBarService,
    @Inject(MAT_DIALOG_DATA) private data: {
      column: ColumnForEdit
    }
  ) {
    this.tempColumn = Object.assign({}, this.data.column)
  }

  ngOnInit(): void {

  }

  saveDict() {
    this.saveLoading = true;

    this.adminPanelService.saveColumnCondition(this.tempColumn).subscribe(newDict => {
      this.miscSnackBarService.openSuccessSnackBar('Success!')

      this.dialogRef.close(newDict);
    }, error => {
      this.miscSnackBarService.openErrorSnackBar(error.message)
      this.saveLoading = false;
    })
  }

  closeDialog() {
    this.dialogRef.close('close-button');
  }
}
